import Http from "./Http";

export class EmailsService extends Http {
  /**
   * Send email to Honeymakers team
   * @param {Object} body
   * @param {string} body.name
   * @param {string} body.email
   * @param {string} body.message
   * @param {number} body.requestContentFormId
   */
  sendEmailToFam(body) {
    return this.post("/emails/contact-us", body);
  }
}

export default new EmailsService();
